// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_TeveUmProblemaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type WizardServicos_TeveUmProblemaResponseDados = boolean;

export type WizardServicos_TeveUmProblemaResponse = ApiResponse<WizardServicos_TeveUmProblemaResponseDados>;

registerResponseContract('WizardServicos_TeveUmProblemaResponse', {})
